// extracted by mini-css-extract-plugin
export default {"tabContent":"styles__tabContent___ilMhV","body":"styles__body____fQMX","error":"styles__error___jeh0i"};